<template>
    <div class="container-fluid" id="dvconfig">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaconfiguracao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnecomconfig" class="card">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaconfiguracao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="tabvisaogeral" data-toggle="tab" href="#dvvisaogeral" role="tab" aria-controls="Visão Geral" aria-selected="true"><i class="fa fa-bar-chart" aria-hidden="true"></i> Visão Geral</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabprevia" data-toggle="tab" href="#dvprevia" role="tab" aria-controls="Prévia" aria-selected="true"><i class="fa fa-paint-brush" aria-hidden="true"></i> Tema</a>
                                    </li>
                                    <li class="nav-item" @click.prevent="mtdcarregaimagensecommerce()">
                                        <a class="nav-link" id="tabimagens" data-toggle="tab" href="#dvimagens" role="tab" aria-controls="Imagens" aria-selected="false"><i class="fa fa-picture-o" aria-hidden="true"></i> Imagens</a>
                                    </li>                                    
                                    <li class="nav-item" @click.prevent="mtdcarregadestaquesprodutos()">
                                        <a class="nav-link" id="tabdestaques" data-toggle="tab" href="#dvdestaques" role="tab" aria-controls="Destaques" aria-selected="false"><i class="fa fa-line-chart" aria-hidden="true"></i> Destaques de Produtos</a>
                                    </li>
                                    <li class="nav-item" @click.prevent="mtdcarregacategoriasprodutos()">
                                        <a class="nav-link" id="tabcategorias" data-toggle="tab" href="#dvcategorias" role="tab" aria-controls="Categorias" aria-selected="false"><i class="fa fa-sitemap" aria-hidden="true"></i> Categorias de Produtos</a>
                                    </li>                                    
                                    <li class="nav-item" @click.prevent="mtdcarregatransportadora()">
                                        <a class="nav-link" id="tabentrega" data-toggle="tab" href="#dventrega" role="tab" aria-controls="Entrega" aria-selected="false"><i class="fa fa-truck" aria-hidden="true"></i> Entrega</a>
                                    </li>
                                    <li class="nav-item" @click.prevent="mtdcarregadadosfinanceiro()">
                                        <a class="nav-link" id="tabfinanceiro" data-toggle="tab" href="#dvfinanceiro" role="tab" aria-controls="Financeiro" aria-selected="false"><i class="fa fa-money" aria-hidden="true"></i> Financeiro</a>
                                    </li>                                                
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" id="dvconteudotab" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div class="tab-pane container-fluid fade show active" id="dvvisaogeral" role="tabpanel" aria-labelledby="visaogeral-tab">
                                        <div class="row" style="margin-bottom: 20px;">
                                            <div class="col-6 col-sm-6 col-md-6 col-lg-6 mt-4">
                                                <div class="alert alert-info" role="alert" style="position: relative;">
                                                    <span class="badge badge-success" style="background-color: #0acf97; z-index: 999; width: 90px; position: absolute; right:  -35px; top: 0px; transform: rotate(35deg)">EM BREVE</span>
                                                    <h6>
                                                        <strong>
                                                        Aqui você terá acesso completo ao gerenciamento do seu marketplace. <br>
                                                        Acompanhe métricas detalhadas de acessos, visualize gráficos de desempenho em vendas, 
                                                        consulte o histórico completo de pedidos e monitore a disponibilidade do seu e-commerce de forma prática e intuitiva.
                                                        </strong>
                                                    </h6>
                                                </div>
                                           </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane container-fluid" id="dvprevia" role="tabpanel" aria-labelledby="previa-tab">
                                        <div class="row" style="margin-bottom: 20px;">
                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">

                                                <!--Tema de cores-->
                                                <label for="cbtemacores">Tema de cores:</label>
                                                <select name="cbtema" class="form-control form-control-sm" id="cbtemacores" v-model="vtemafilial">
                                                    <option value="padrao">Padrão</option>
                                                    <option value="lilas">Lilás</option>
                                                    <option value="preto">Preto</option>
                                                    <option value="vermelho">Vermelho</option>
                                                    <option value="laranja">Laranja</option>
                                                    <option value="verde">Verde</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button class="btn btn-success btn-sm btn-definirtema" @click.prevent="mtdconfirmatemafilial"><i class="fa fa-paint-brush" aria-hidden="true"></i> Definir tema</button>
                                            </div>
                                            <div class="col-sm-12 col-md-1 col-lg-1 card">
                                                <label for="cbordemmonitora">Tema atual:</label>
                                                <input type="text" class="form-control form-control-sm" id="edcordefinida" style="background-color: #fff; margin-bottom: 8px;" v-model="temaescolhidocomputado" disabled/>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <!--Container de prévia de imagem-->
                                                <div class="container-previa-img">
                                                    <img style="width: 100%;" :src="urlpreviatema" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dvimagens" role="tabpanel" aria-labelledby="imagens-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 600;">Logos da Filial</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="container-selecaoimagens col-sm-6 col-md-3 col-lg-3 card">
                                                <label for="iplogoprincipal">Logo Principal:*</label>
                                                <input
                                                    type="file" 
                                                    id="iplogoprincipal"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem($event, 'principal')" 
                                                    style="display: none;"
                                                    ref="click_logoprincipal">
                                                <div v-if="urllogoprincipal" class="imagem-selecionada">
                                                    <img :src="urllogoprincipal" alt="" style="width: 100%;">
                                                    <div class="container-remover-imagem">
                                                        <button @click.prevent="mtdconfirmaremoverimagem('logoprincipal', logoprincipal.arquivo)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else class="selecionar-imagem" @click="$refs.click_logoprincipal.click()">
                                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                                    <span>Selecionar Imagem</span>
                                                </div>
                                            </div>                                                                   
                                            <div class="container-selecaoimagens col-sm-4 col-md-2 col-lg-2 card">
                                                <label for="iplogosecundaria">Logo Secundária:*</label>
                                                <input
                                                    type="file" 
                                                    id="iplogosecundaria"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem($event, 'secundaria')" 
                                                    style="display: none;"
                                                    ref="click_logosecundaria">
                                                <div v-if="urllogosecundaria" class="imagem-selecionada">
                                                    <img :src="urllogosecundaria" alt="" style="width: 100%;">
                                                    <div class="container-remover-imagem">
                                                        <button @click.prevent="mtdconfirmaremoverimagem('logosecundaria', logosecundaria.arquivo)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else class="selecionar-imagem" @click="$refs.click_logosecundaria.click()">
                                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                                    <span>Selecionar Imagem</span>
                                                </div>
                                            </div>                                                                   
                                            <div class="container-selecaoimagens col-sm-2 col-md-1 col-lg-1 card" style="height: 150px;">
                                                <label for="iplogoicone">ícone:</label>
                                                <input
                                                    type="file" 
                                                    id="iplogoicone"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem($event, 'icone')" 
                                                    style="display: none;"
                                                    ref="click_logoicone">
                                                <div v-if="urllogoicone" class="imagem-selecionada">
                                                    <img :src="urllogoicone" alt="" style="width: 100%;">
                                                    <div class="container-remover-imagem">
                                                        <button @click.prevent="mtdconfirmaremoverimagem('icone', logoicone.arquivo)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                    </div>
                                                </div>
                                                <div v-else class="selecionar-imagem" @click="$refs.click_logoicone.click()" style="height: 85px; text-align: center;">
                                                    <i class="fa fa-upload icon-icone" aria-hidden="true" style="font-size: 20px;"></i>
                                                    <span class="span-icone">Selecionar Imagem</span>
                                                </div>
                                                <small style="float: right;">(Opcional)</small>
                                            </div>                                                                   
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 600;">Banners Carrossel</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="container-selecaoimagens col-sm-6 col-md-5 col-lg-5 card">
                                                <label for="ipbannercarrossel">Adicionar Imagem:*</label>
                                                <input
                                                    type="file" 
                                                    id="ipbannercarrossel"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem($event, 'carrossel')" 
                                                    style="display: none;"
                                                    ref="click_bannercarrossel">
                                                <div class="selecionar-imagem" @click="$refs.click_bannercarrossel.click()">
                                                    <i class="fa fa-upload" aria-hidden="true"></i>
                                                    <span>Adicionar Imagem</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="lstbannerscarrossel.length > 0" class="row">
                                            <div v-for="(banner, index) in lstbannerscarrossel" class="banners-carrossel col-sm-12 col-md-6 col-lg-6">
                                                <div class="card">
                                                    <img :src="'https://' + $store.state.usuario.adrsrv + '/' + banner.patharquivo">
                                                    <div class="container-remover-imagem">
                                                        <button @click.prevent="mtdconfirmaremoverimagemcarrossel('bannerscarrossel', banner.arquivo)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                    <div class="tab-pane fade container-fluid" id="dvdestaques" role="tabpanel" aria-labelledby="destaques-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row" style="margin-bottom: 20px;">
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edid">Código:</label>
                                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vcoddestaque"
                                                            maxlength="20" disabled/>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                        <label for="edid">Título:</label>
                                                        <input type="text" class="form-control form-control-sm" id="edtitulo" v-model="vtitulodestaque"/>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                        <button class="btn btn-success btn-sm btn-incluir" @click.prevent="mtdincluirdestaqueprodutos"><i class="fa fa-plus-circle" aria-hidden="true"></i> Incluir</button>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="refdestaquesprodutos"
                                                        :rows="lstdestaquesprodutos"
                                                        :columns="columns"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button @click.prevent="mtdpreparaalteracaodestaque(item.row)" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" title="Alterar"><i class="fa fa-edit"></i></button>
                                                        <button @click.prevent="mtdconfirmaremocaodestaque(item.row.id)" type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" title="Excluir"><i class="fa fa-trash"></i></button>
                                                        <button @click.prevent="mtdlistaprodutosdestaque(item.row)" type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" title="Produtos do Destaque"><i class="fa fa-cubes" aria-hidden="true"></i></button>
                                                    </template>
                                                    <template slot="slot_ativo" slot-scope="item">
                                                        <span v-if="parseInt(item.row.ativo) === 1" class="badge badge-primary" style="background-color: green;">Exibindo</span>
                                                        <span v-else class="badge badge-danger">Não exibindo</span>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dvcategorias" role="tabpanel" aria-labelledby="categorias-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row" style="margin-bottom: 20px;">
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="cbgrupocategoria">*Grupos:</label>
                                                        <select id="cbgrupocategoria" data-placeholder="Selecione um grupo" data-allow-clear="true"
                                                                style="width:100%;" v-model="vidgrupocategoria">
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4 col-lg-2">
                                                        <button class="btn btn-success btn-sm btn-incluir" :disabled="lstgruposcategorias.length >= 5" 
                                                            @click.prevent="mtdincluircategoriasprodutos" @mouseover="showMsgIncluir = lstgruposcategorias.length >= 5" 
                                                            @mouseleave="showMsgIncluir = false">
                                                            <i class="fa fa-plus-circle" aria-hidden="true"></i> Incluir
                                                        </button>
                                                        <transition name="fade">
                                                            <div v-if="showMsgIncluir" class="tooltip-message" style="color: white; font-size: 12px;">
                                                                O máximo de registros (5) já foi atingido.
                                                            </div>
                                                        </transition>
                                                    </div>
                                                    <div v-show="lstgruposcategorias.length === 5" class="col-sm-12 col-md-4 col-lg-6" style="font-weight: 500;">
                                                        <i class="fa fa-check" style="color: #008000; margin-top: 35px;"></i> Exibindo no ecommerce.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">Caso não sejam selecionadas categorias para o topo, serão exibidas categorias de produtos aleatórias.</h5>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="refdestaquesprodutos"
                                                        :rows="lstgruposcategorias"
                                                        :columns="columnscat"
                                                        :config="config"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button @click.prevent="mtdconfirmaremocaocategoria(item.row.idcategoria)" type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" title="Excluir"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;">É necessário adicionar <strong>5 GRUPOS</strong> para que sejam exibidos no ecommerce.</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade container-fluid" id="dventrega" role="tabpanel" aria-labelledby="entrega-tab">
                                        <!-- <div class="row mt-2">
                                            <div class="col-6">
                                                CONFIGURAÇÕES DE ENTREGA
                                            </div>
                                        </div> -->
                                        <div class="row mt-4 pt-2">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 500; font-size: 18px;"><i class="fa fa-truck" aria-hidden="true"></i> Transportadoras disponíveis</h5>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input type="checkbox" @click="mtdconfirmadesabilitarecommerce()" class="custom-control-input" id="swentregainput" v-model="ativocorreios" name="swentregainput">
                                                    <label class="custom-control-label" for="swentregainput">
                                                        Correios
                                                        <span v-if="ativocorreios" class="badge badge-primary ml-3" style="background-color: green;">Ativo</span>
                                                        <span v-else class="badge badge-danger ml-3">Inativo</span>
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosEntregaCorreios">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-sm-12 col-md-2 col-lg-6">
                                                                        <label for="cbtransportadora">*Transportadora:</label>
                                                                        <select id="cbtransportadora" v-model="vtransportadora"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Serviços</strong></h5>

                                                                        <div class="form-check mt-2">
                                                                            <input class="form-check-input" type="checkbox" id="pac" value="03298" v-model="servicosSelecionados">
                                                                            <label class="form-check-label" for="pac">PAC à vista</label>
                                                                        </div>

                                                                        <div class="form-check mt-2">
                                                                            <input class="form-check-input" type="checkbox" id="sedex" value="03220" v-model="servicosSelecionados">
                                                                            <label class="form-check-label" for="sedex">SEDEX à vista</label>
                                                                        </div>

                                                                        <!-- <div class="form-check mt-2">
                                                                            <input class="form-check-input" type="checkbox" id="sedex10" value="03158" v-model="servicosSelecionados">
                                                                            <label class="form-check-label" for="sedex10">SEDEX 10</label>
                                                                        </div>

                                                                        <div class="form-check mt-2">
                                                                            <input class="form-check-input" type="checkbox" id="sedex12" value="03140" v-model="servicosSelecionados">
                                                                            <label class="form-check-label" for="sedex12">SEDEX 12</label>
                                                                        </div> -->
                                                                    </div>
                                                                    <!-- <div class="col-sm-12">
                                                                        <label for="cbobservacoes">Observações da entrega:</label>
                                                                        <textarea class="form-control center" rows="8" id="txtobs" v-model="vobservacoes"></textarea>
                                                                    </div> -->
                                                                    <div class="col-sm-12 col-md-2 col-lg-2 ">
                                                                        <button @click.prevent="mtdconfirmatransportadoraecommerce()" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Selecionar
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>                                                                      
                                    <div class="tab-pane fade container-fluid" id="dvfinanceiro" role="tabpanel" aria-labelledby="financeiro-tab">
                                        <div class="row mt-2">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 500; font-size: 18px;"><i class="fa fa-cogs" aria-hidden="true"></i> Definições de tabelas padrão</h5>
                                                <hr>
                                            </div>
                                        </div>
                                        <div class="row card card-financeiro">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbplanopagamento">*Plano de pagamento:</label>
                                                <select id="cbplanopagamento" data-placeholder="Selecione um plano" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidplano">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Estoque:</span>
                                                <select id="cbestoque" data-placeholder="Selecione um estoque" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Vendedor:</span>
                                                <select id="cbvendedor" data-placeholder="Selecione um vendedor" v-model="vidvendedor" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <button class="btn btn-success btn-sm btn-definirtema" @click.prevent="mtdconfirmaalteracaotabelaspadrao()"><i class="fa fa-check" aria-hidden="true"></i> Definir tabelas</button>
                                            </div>
                                        </div>
                                        <div class="row mt-4 pt-2">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 500; font-size: 18px;"><i class="fa fa-credit-card" aria-hidden="true"></i> Métodos de pagamento disponíveis</h5>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarpix()" type="checkbox" class="custom-control-input" id="swformapixinput" v-model="swformapix" name="swformapixinput">
                                                    <label class="custom-control-label" for="swformapixinput">
                                                        Pix
                                                        <span v-if="vformapix" class="badge badge-primary ml-3" style="background-color: green;">Ativo</span>
                                                        <span v-else class="badge badge-danger ml-3">Inativo</span>
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosFormaPix">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbidformapix">*Forma de pagamento:</label>
                                                                        <select id="cbidformapix" v-model="vidformapix"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="cbcontapix">*Conta bancária:</label>
                                                                        <select id="cbcontapix" v-model="vidcontapix"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="edchavepix" style="width: 100%;">
                                                                            Chave Pix Beneficiário:
                                                                            <span class="badge badge-info" style="float: right;">{{ vtipochavepixpix }}</span>
                                                                        </label>
                                                                        <input type="text" class="form-control form-control-sm" id="edchavepix" v-model="vchavepixpix"
                                                                        disabled style="background-color: #fff;" @mouseover="showMsgPix = 1" @mouseleave="showMsgPix = 0"/>
                                                                        <transition name="fade">
                                                                            <div v-if="showMsgPix" class="tooltip-message">
                                                                                Chave pix definida no cadastro de contas bancárias.
                                                                            </div>
                                                                        </transition>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbperfilfluxopix">Perfil fluxo:</label>
                                                                        <select id="cbperfilfluxopix" v-model="vidperfilfluxopix" 
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>      
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <button v-if="!vformapix" @click.prevent="mtdconfirmaalteracaopix('habilitar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Habilitar
                                                                        </button>
                                                                        <button v-if="vformapix" @click.prevent="mtdconfirmaalteracaopix('alterar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Aplicar alterações
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarcartaocred()" type="checkbox" class="custom-control-input" id="swformacartaocredinput" v-model="swformacartaocred" name="swformacartaocredinput">
                                                    <label class="custom-control-label" for="swformacartaocredinput">
                                                        Cartão de Crédito
                                                        <span v-if="vformacartaocred" class="badge badge-primary ml-3" style="background-color: green;">Ativo</span>
                                                        <span v-else class="badge badge-danger ml-3">Inativo</span>
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosFormaCartao">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbidformacartaocred">*Forma de pagamento:</label>
                                                                        <select id="cbidformacartaocred" v-model="vidformacartaocred"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="cbcontacartaocred">*Conta bancária:</label>
                                                                        <select id="cbcontacartaocred" v-model="vidcontacartaocred"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="edapicartaocred" style="width: 100%;"> Gateway de Pagamento:</label>
                                                                        <span v-if="vapicartaocred == null" class="badge badge-secondary pl-2 pr-2">AGUARDANDO SELEÇÃO</span>
                                                                        <span v-if="vapicartaocred == 0" class="badge badge-info pl-2 pr-2" style="background-color: #b62121;">CONTA BANCÁRIA NÃO VÁLIDA</span>
                                                                        <span v-if="vapicartaocred == 21" class="badge badge-info pl-2 pr-2" style="background-color: #009b55;">PAGAR ME</span>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbperfilfluxocartaocred">Perfil fluxo:</label>
                                                                        <select id="cbperfilfluxocartaocred" v-model="vidperfilfluxocartaocred" 
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>      
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <button v-if="!vformacartaocred" @click.prevent="mtdconfirmaalteracaocartaocred('habilitar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Habilitar
                                                                        </button>
                                                                        <button v-if="vformacartaocred" @click.prevent="mtdconfirmaalteracaocartaocred('alterar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Aplicar alterações
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>                                                                 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <!-- <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button> -->
                            </div>
                            <div class="col-sm-2">
                                <!-- <button type="button" @click.prevent="mtdcancelaconfiguracao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Voltar
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>    
        <modal name="modalCropImage" height="auto">
            <div class="container-cropper card">
                <div class="card-header titulo-cropper">
                    <h4>Recorte da imagem</h4>
                    <p><i class="fa fa-object-group" aria-hidden="true"></i> {{ tituloCropper }}</p>
                </div>
                <div class="card-body body-cropper">
                    <cropper
                        ref="cropper"
                        :src="imgselecionada"
                        :stencil-props="{
                            aspectRatio: aspectRatioCropper,
                            scalable: scalableCropper,
                        }"
                    />
                </div>
                <div class="card-footer">
                    <small>Proporção da imagem:</small>
                    <div class="aspectRatios">
                        <button v-if="opimagem === 1 || opimagem === 2" @click="mtdalteraproporcaocropper('livre')" class="btn-aspectratio">Livre</button>
                        <button v-if="opimagem === 1 || opimagem === 2 || opimagem === 3" @click="mtdalteraproporcaocropper('1:1')" class="btn-aspectratio"><div class="p1-1"></div><small>1:1</small></button>
                        <button v-if="opimagem === 4" @click="mtdalteraproporcaocropper('27:9')" class="btn-aspectratio"><div class="p27-9"></div><small>27:9</small></button>
                        <button v-if="opimagem === 4" @click="mtdalteraproporcaocropper('25:9')" class="btn-aspectratio"><div class="p25-9"></div><small>25:9</small></button>
                        <button v-if="opimagem === 4" @click="mtdalteraproporcaocropper('23:9')" class="btn-aspectratio"><div class="p23-9"></div><small>23:9</small></button>
                        <button v-if="opimagem === 1 || opimagem === 2 || opimagem === 4" @click="mtdalteraproporcaocropper('16:9')" class="btn-aspectratio"><div class="p16-9"></div><small>16:9</small></button>
                    </div>
                    <div class="btns-cropper">
                        <button @click.prevent="mtdcancelaselecaoimagem" class="btn btn-secondary">Cancelar</button>
                        <button @click.prevent="mtdconfirmaimagemcortada" class="btn btn-primary">Salvar Alterações</button>
                    </div>    
                </div>
            </div>
        </modal>
        <modal name="modalAlteraDestaque" height="auto">
            <div class="container-cropper card">
                <div class="card-header titulo-cropper">
                    <h4>Alteração de Destaque</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <label for="ediddestaque">Código:</label>
                            <input type="text" class="form-control form-control-sm" id="ediddestaque" v-model="destaquealterar.id"
                                maxlength="20" disabled/>
                        </div>
                        <div class="col-sm-12 col-md-8 col-lg-8">
                            <label for="eddescricaodestaque">Título:</label>
                            <input type="text" class="form-control form-control-sm" id="eddescricaodestaque" v-model="destaquealterar.descricao"/>
                        </div>
                        <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 25px;">
                            <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                <input type="checkbox" class="custom-control-input" id="swdestaqueativo"
                                name="swdestaqueativo" v-model="destaquealterar.ativo">
                                <label class="custom-control-label" for="swdestaqueativo">Ativo</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="btns-editdestaque">
                        <button @click.prevent="mtdcancelaalteracaodestaque()" class="btn btn-secondary">Cancelar</button>
                        <button @click.prevent="mtdalterardestaqueprodutos()" class="btn btn-primary">Alterar</button>
                    </div>    
                </div>
            </div>
        </modal>
        <modal name="modalProdutosDestaque" height="auto" width="700">
            <div class="card">
                <div class="card-header titulo-modal-destaque">
                    <h2>PRODUTOS DO DESTAQUE</h2>
                    <small><i class="fa fa-line-chart" aria-hidden="true"></i> MAIS VENDIDOS</small>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-3 col-lg-3">
                            <label for="edcodprod">*Produto:</label>
                            <div class="input-group">
                                <input type="text" class="form-control form-control-sm" id="edcodprod" @input="vprodutodescricao = ''" v-model="vcodproddestaque" maxlength="20" v-on:blur="mtdlocalizarproduto(vcodproddestaque)" v-on:keyup.13="mtdlocalizarproduto(vcodproddestaque)" style="text-transform: uppercase;">
                                <div class="input-group-append">
                                    <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarprodutodestaque()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                </div>
                            </div>
                        </div>  
                        <div class="col-sm-12 col-md-7 col-lg-7">
                            <label for="eddescricaodestaque">Descrição do Produto:</label>
                            <input type="text" class="form-control form-control-sm" id="eddescricaodestaque" v-model="vprodutodescricao" disabled/>
                        </div>
                        <div class="col-sm-12 col-md-2 col-lg-2">
                            <button class="btn btn-success btn-sm btn-incluir-produto" @click.prevent="mtdincluirprodutodestaque()" :disabled="ativadesativaincluirproduto"><i class="fa fa-plus-circle" aria-hidden="true"></i> Incluir</button>
                        </div> 
                    </div>
                    <div v-show="lstprodutosdestaque.length > 0" class="row mt-4">
                        <div class="col-md-12" style="max-height: 40vh; overflow-y: auto">
                            <vue-bootstrap4-table ref="refprodutosdestaque"
                                    :rows="lstprodutosdestaque"
                                    :columns="columns2"
                                    :config="config2"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>                                    
                                <!--  -->
                                <template slot="slot_opproddest" slot-scope="item">
                                    <button @click.prevent="mtdremoverprodutodestaque(item.row)" type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" title="Remover Produto"><i class="fa fa-trash"></i></button>
                                </template>
                                <template slot="slot_exibicao" slot-scope="item">
                                    <span v-if="parseInt(item.row.ecommerce) === 1" class="badge badge-primary" style="background-color: green;" title="Habilitado para exibição no ecommerce no cadastro de produtos.">Exibindo</span>
                                    <span v-else-if="parseInt(item.row.ecommerce) === 0" class="badge badge-danger" title="Desabilitado para exibição no ecommerce no cadastro de produtos.">Produto indisponível</span>
                                </template>
                            </vue-bootstrap4-table>
                        </div>
                    </div>
                </div>
                <div class="card-footer card-footer-prod">
                    <div class="btns-editprodutos">
                        <button @click.prevent="mtdcancelaalteracaoprodutodestaque()" class="btn btn-secondary">Cancelar</button>
                        <button @click.prevent="mtdconfirmaprodutosdestaque()" class="btn btn-primary">Salvar Alterações</button>
                    </div>    
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'ecommerceconfig',
        components:{
            VueBootstrap4Table,
            'consultaprodutos'  : ConsultarProdutos,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstusuarios                 : [],
                idfilialselecionada         : null,
                pfiltro                     : 1,
                pconteudo                   : '',
                pativo                      : 2,
                pqtdregistros               : 10,
                pqtd_paginas                : 1,
                pagina_atual                : 1,
                pqtd_total_registros        : 0,

                //variáveis do crud
				crotinacortes		    : false,//variável para permissão do usuário
                vcoddestaque                : '',
                vtitulodestaque             : '',
                vativodestaques             : 1,
                //variável para habilitação dos campos

                //variável p/ clonar configs filial
                vcodfilcopiarconfig         : null,


                //rotina temas
                vtemafilial                 : 'padrao',
                temafilial                  : '',
                urlpreviatema               : '',

                //rotina imagens
                opimagem                    : 0,
                imgselecionada              : null,
                extimgselecionada           : null,
                imgparaupload               : null,
                tituloCropper               : 'Livre',
                aspectRatioCropper          : null,
                scalableCropper             : false,


                logoprincipal               : null,
                logosecundaria              : null,
                logoicone                   : null,
                lstbannerscarrossel         : [],
                //pega o path do diretorio padrão das imagens
                pathimagensecommerce        : this.$store.state.configpaths.pathimagens,

                //rotina destaques produtos
                lstdestaquesprodutos        : [],
                lstprodutosdestaque         : [],
                destaquealterar             : {},
                vcodproddestaque            : null,
                vprodutodescricao           : '',
                
                //rotina categorias produtos
                lstgruposcategorias         : [],
                showMsgIncluir              : false,
                
                //variaveis da consulta de produtos
                opcrud                      : 3,
				vshowprtabela			    : false,//oculta a visualização do preço do produto na listagem
				vidtabela				    : 1,//informo somente pq o componente exige
                tipopropesquisa             : '',

                // variaveis formas de pagamento
                vidplano                    : null,
                videstoque                  : null,
                vidvendedor                 : null,
                
                // pix
                swformapix                  : false,
                vformapix                   : false,
                showMsgPix                  : 0,
                vidformapix                 : null,
                vidcontapix                 : null,
                vtipochavepixpix            : '',
                vchavepixpix                : '',
                vidperfilfluxopix           : null,
                
                // cartão de crédito
                swformacartaocred           : false,
                vformacartaocred            : false,
                vidformacartaocred          : null,
                vidcontacartaocred          : null,
                vidperfilfluxocartaocred    : null,
                vapicartaocred              : null,

                // variaveis categorias
                vidgrupocategoria           : null,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },

                // variaveis transportadora
                servicosSelecionados: [], 
                vtransportadora     : null,
                // vobservacoes        : '',
                lsttransportadora   : [],
                ativocorreios       : false,

                itensbc : {
                    item1 : {
                        titulo : 'FILIAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : 'CONFIGURAÇÕES E-COMMERCE',
                        ativo  : true
                    }
                },

                columns: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoess",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "slot_id",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Título do destaque",
                        name: "descricao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_titulo",
                        row_classes: "def-col-titulo",
                    },
                    {
                        label: "Exibição do destaque",
                        name: "ativo",
                        slot_name: "slot_ativo",
                        row_classes: "def-col-ativo",
                    },
                ],
                columnscat: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoescat",
                        sort: false
                    },
                    {
                        label: "Id grupo",
                        name: "idgrupo",
                        sort: true,
                        slot_name: "slot_idgrupo",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descgrupo",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_descgrupo",
                        row_classes: "def-col-descgrupo",
                    },
                ],
                columns2: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opproddest",
                        slot_name: "slot_opproddest",
                        sort: false
                    },    
                    {
                        label: "Código",
                        name: "idproduto",
                        sort: true,
                        slot_name: "slot_idprod",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição do Produto",
                        name: "descricao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_descricao",
                        row_classes: "def-col-descricao",
                    },
                    {
                        label: "Status",
                        name: "ecommerce",
                        slot_name: "slot_exibicao",
                        row_classes: "def-col-exibicao",
                    },
                ],

                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                config2: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdconfirmatransportadoraecommerce(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'servicoscorreios'  : this.servicosSelecionados,
                    'ativo'             : this.ativocorreios === true ? 1 : 0,
                    'idtransportadora'  : this.vtransportadora,
                    'descricao'         : 'CORREIOS',
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrudentregacorreios'},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    // {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        console.log(response.data)
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmadesabilitarecommerce(){
                let vself = this;
                if (vself.ativocorreios ) {
                    
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja desabilitar a transportadora Correios?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'red',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-red',
                                action: function () {
                                    vself.mtddesabilitarmetodocorreios();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    vself.mtdcarregatransportadora();
                                    return
                                }
                            }
                        }
                    });
                }
            },
            mtddesabilitarmetodocorreios(){
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'servicoscorreios'  : this.servicosSelecionados,
                    'ativo'             : this.ativocorreios === true ? 1 : 0,
                    'idtransportadora'  : this.vtransportadora,
                    'descricao'         : 'CORREIOS',
                }
                let parametros = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrudentregacorreios'},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método da transportadora correios desabilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregatransportadora();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            // mtdcarregatransportadora(){
            //     let vself = this;
            //     let loader = vself.$loading.show();
            //     let parametros = [
            //         {parametro: 'op'            , valor: 'listagementrega'},
            //         {parametro: 'idclientesac'  , valor: vself.$store.state.usuario.idclientesac},
            //         {parametro: 'idfilial'      , valor: vself.idfilialselecionada}
            //     ];
            //     let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
            //     retorno.then(function (response) {
            //         loader.hide();
            //         vself.servicosSelecionados = response.data.servicoscorreios;
            //         vself.ativocorreios = response.data.ativo == 1 ? true : false;
            //         if (parseInt(response.data.idtransportadora) > 0){
            //             vself.vtransportadora       = response.data.idtransportadora;
            //             var deftransportadora = new Option(response.data.fantasia, vself.vtransportadora, true, true);
            //             $('#cbtransportadora').append(deftransportadora).trigger('change');
            //         } else { 
            //             vself.vtransportadora       = null; 
            //         }
            //     }).catch(function (response) {
            //         loader.hide();
            //         console.log(response.message);
            //     });
            // },
            mtdcarregatransportadora(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op'           , valor: 'listagementrega'},
                    {parametro: 'idclientesac' , valor: vself.$store.state.usuario.idclientesac},
                    {parametro: 'idfilial'     , valor: vself.idfilialselecionada}
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtecommerceconfig.php');

                retorno.then(function (response) {
                    loader.hide();
                    let transportadoras = response.data.transportadoras || {};
                    if (transportadoras.CORREIOS) {
                        let correios = transportadoras.CORREIOS;
                        vself.servicosSelecionados = correios.servicoscorreios;
                        vself.ativocorreios = correios.ativo == 1 ? true : false;
                        if (parseInt(correios.idtransportadora) > 0) {
                            vself.vtransportadora = correios.idtransportadora;
                            let deftransportadora = new Option(correios.fantasia, vself.vtransportadora, true, true);
                            $('#cbtransportadora').append(deftransportadora).trigger('change');
                        } else {
                            vself.vtransportadora = null;
                        }
                    } else {
                        vself.servicosSelecionados = [];
                        vself.ativocorreios = false;
                        vself.vtransportadora = null;
                    }

                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            },

            formatarCNPJ(cnpj){
                return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
            },
            formatarCPF(cpf){
                return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
            },
            formatarCelular(celular){
                return celular.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
            },
            mtdcancelaconfiguracao(){
                this.$router.go(-1);
            },
            mtdcarregacategoriasprodutos(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op'            , valor: 'listagemcategoriasprodutos'},
                    {parametro: 'idclientesac'  , valor: vself.$store.state.usuario.idclientesac},
                    {parametro: 'idfilial'      , valor: vself.idfilialselecionada}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstgruposcategorias = response.data.lstgruposcategorias;
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            },
            mtdcarregadestaquesprodutos(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op'            , valor: 'listagemdestaques'},
                    {parametro: 'idclientesac'  , valor: vself.$store.state.usuario.idclientesac},
                    {parametro: 'idfilial'      , valor: vself.idfilialselecionada}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstdestaquesprodutos = response.data.lstdestaques;
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            },
            mtdincluircategoriasprodutos() {
                let vself = this;
                if (vself.vidgrupocategoria == '') {
                    vself.$toastr.w('Informe o grupo!', 'Atenção!');
                    $('#cbgrupocategoria').focus();
                    return;
                }

                let loader = vself.$loading.show();
                let registrocrud = {
                    'idgrupo': vself.vidgrupocategoria,
                    'idfilial': vself.idfilialselecionada,
                };

                let parametros = [
                    { parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'op', valor: 'rotinacrudcategoriaproduto' },
                    { parametro: 'opcrud', valor: 1 },
                    { parametro: 'registro', valor: JSON.stringify(registrocrud) },
                    { parametro: 'idfilial', valor: vself.idfilialselecionada },
                    { parametro: 'idusuario', valor: vself.$store.state.usuario.id },
                    { parametro: 'codop', valor: '010Z.005Z.010Z' },
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (response.data.status === 'error') {
                        vself.$toastr.e(response.data.message, 'Erro!');
                        $("#cbgrupocategoria").val('').trigger('change');
                    } else if ($.isNumeric(response.data)) {
                        vself.$toastr.s('Categorias de Produtos incluído com sucesso!', 'Informação!');
                        $("#cbgrupocategoria").val('').trigger('change');
                        vself.mtdcarregacategoriasprodutos();
                    } else {
                        let tpret = response.data.substring(0, 1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E':
                            default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (error) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registro. Descrição do erro: ' + error.message, 'Erro!');
                });
            },

            mtdincluirdestaqueprodutos(){
                if (this.vtitulodestaque == ''){
                    this.$toastr.w('Informe o título do destaque!', 'Atenção!');
                    $('#edtitulo').focus();
                    return;
                }
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'descricao'      : this.vtitulodestaque,
                    'idfilial'       : this.idfilialselecionada,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacruddestaque'},
                    {parametro: 'opcrud',       valor : 1},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Destaque de produto incluído com sucesso!', 'Informação!');
                        vself.vtitulodestaque = '';
                        vself.mtdcarregadestaquesprodutos();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdpreparaalteracaodestaque(destaque){
                this.destaquealterar = destaque;
                console.log(this.destaquealterar);
                this.$modal.show('modalAlteraDestaque');
            },
            mtdcancelaalteracaodestaque(){
                this.destaquealterar = {};
                this.$modal.hide('modalAlteraDestaque');
            },
            mtdalterardestaqueprodutos(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'            : vself.destaquealterar.id,
                    'descricao'     : vself.destaquealterar.descricao,
                    'ativo'         : vself.destaquealterar.ativo,
                    'idfilial'      : vself.idfilialselecionada,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacruddestaque'},
                    {parametro: 'opcrud',       valor : 2},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Destaque de produto alterado com sucesso!', 'Informação!');
                        vself.vtitulodestaque = '';
                        vself.mtdcarregadestaquesprodutos();
                        vself.mtdcancelaalteracaodestaque();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaremocaodestaque(iddestaque){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma remover o destaque?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'red',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdremoverdestaqueprodutos(iddestaque);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdremoverdestaqueprodutos(iddestaque){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'            : iddestaque,
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacruddestaque'},
                    {parametro: 'opcrud',       valor : 3},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Destaque de produto excluído com sucesso!', 'Informação!');
                        vself.vtitulodestaque = '';
                        vself.mtdcarregadestaquesprodutos();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaremocaocategoria(idcategoria){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma remover o categoria?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'red',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdremovercategoriaprodutos(idcategoria);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdremovercategoriaprodutos(idcategoria) {
                let vself        = this;
                let loader       = vself.$loading.show();
                let registrocrud = {
                    'idcategoria'   : idcategoria,
                    'idfilial'      : vself.idfilialselecionada,
                };

                let parametros = [
                    { parametro: 'idclientesac',    valor: vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'op',              valor: 'rotinacrudcategoriaproduto' },
                    { parametro: 'opcrud',          valor: 3 },
                    { parametro: 'registro',        valor: JSON.stringify(registrocrud) },
                    { parametro: 'idfilial',        valor: vself.idfilialselecionada },
                    { parametro: 'idusuario',       valor: vself.$store.state.usuario.id },
                    { parametro: 'codop',           valor: '010Z.005Z.010Z' },
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();

                    if (response.data.status === 'success') {
                        vself.$toastr.s(response.data.message, 'Informação!'); 
                        $("#cbgrupocategoria").val('').trigger('change');
                        vself.mtdcarregacategoriasprodutos();

                    } else if ($.isNumeric(response.data)) {
                        vself.$toastr.s('Categoria de produto excluída com sucesso!', 'Informação!');
                        $("#cbgrupocategoria").val('').trigger('change');
                        vself.mtdcarregacategoriasprodutos();

                    } else {
                        let tpret = response.data.substring(0, 1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E':
                            default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (error) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registro. Descrição do erro: ' + error.message, 'Erro!');
                });
            },
            mtdconfirmaprodutosdestaque(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma alterações dos produtos?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdalterarprodutosdestaque();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdalterarprodutosdestaque(){
                let vself  = this;
                let loader = vself.$loading.show();

                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrudprodutosdestaque'},
                    {parametro: 'produtos',     valor : JSON.stringify(vself.lstprodutosdestaque)},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'iddestaque',   valor : vself.destaquealterar.id},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Produtos do destaque alterados com sucesso!', 'Informação!');
                        vself.mtdcancelaalteracaoprodutodestaque();
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:  
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                        vself.mtdcancelaalteracaoprodutodestaque();
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaimagemcortada(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma o envio da imagem?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdsalvaimagemcortada();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                vself.mtdcancelaselecaoimagem();
                            }
                        }
                    }
                });
            },
            async mtdsalvaimagemcortada() {
                let stringAleatoria = util.GerarStringAleatoria();
                console.log(stringAleatoria)
                this.imgparaupload = null;
                let vself = this;
                // PEGA A IMAGEM RECORTADA E CONVERTE PARA BLOB -> ARQUIVO, DEPOIS ENVIA ELE PARA O SERVIDOR
                const { canvas, } = this.$refs.cropper.getResult();
                const createBlob = () => {
                    return new Promise((resolve) => {
                    canvas.toBlob((blob) => {
                        resolve(blob);
                    }, `image/${this.extimgselecionada}`);
                    });
                };
                let localsalvar = '';
                const blob = await createBlob();
                switch (this.opimagem) {
                    case 1:
                        this.imgparaupload = new File([blob], `${stringAleatoria}.${this.extimgselecionada}`, { type: `image/${this.extimgselecionada}` });
                        localsalvar = 'controller/ecommerce/arquivos/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.idfilialselecionada+'/logoprincipal';
                        break;
                    case 2:    
                        this.imgparaupload = new File([blob], `${stringAleatoria}.${this.extimgselecionada}`, { type: `image/${this.extimgselecionada}` });
                        localsalvar = 'controller/ecommerce/arquivos/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.idfilialselecionada+'/logosecundaria';
                        break;
                    case 3:
                        this.imgparaupload = new File([blob], `${stringAleatoria}.${this.extimgselecionada}`, { type: `image/${this.extimgselecionada}` });
                        localsalvar = 'controller/ecommerce/arquivos/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.idfilialselecionada+'/icone';
                        break;
                    case 4:
                        let nomearquivo = this.lstbannerscarrossel
                        if(nomearquivo.length > 0){
                            nomearquivo = (parseInt(nomearquivo.pop().arquivo.split('-')[0]) + 1) + '-' + stringAleatoria + '.' + this.extimgselecionada;
                        } else {
                            nomearquivo ='1-'+ stringAleatoria + '.' + this.extimgselecionada;
                        }
                        this.imgparaupload = new File([blob], nomearquivo, { type: `image/${this.extimgselecionada}` });
                        localsalvar = 'controller/ecommerce/arquivos/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.idfilialselecionada+'/bannerscarrossel';
                        
                        break;
                }
                
                let loader      = vself.$loading.show();
                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.imgparaupload},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.imgparaupload.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)) {
                        loader.hide();
                        vself.$toastr.s('Imagem carregada com sucesso!', 'Informação!');
                        switch (vself.opimagem) {
                            case 1:
                                vself.logoprincipal = 'https://'+vself.$store.state.usuario.adrsrv+'/'+response.data.arquivos[0].patharquivo;
                            break;
                            case 2:    
                                vself.logosecundaria = 'https://'+vself.$store.state.usuario.adrsrv+'/'+response.data.arquivos[0].patharquivo;
                            break;
                            case 3:
                                vself.logoicone = 'https://'+vself.$store.state.usuario.adrsrv+'/'+response.data.arquivos[0].patharquivo;
                            break;
                            case 4:
                                // FALTA IMPLEMENTAR
                                // vself.lstbannerscarrossel.push(canvas.toDataURL());
                            break;
                        }
                        
                    }else{
                        loader.hide();
                        vself.$toastr.e('Ocorreu um erro ao carregar a imagem: '+response.data.inf, 'Erro!');
                    }                   
                    vself.mtdcarregaimagensecommerce()
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });
                this.mtdcancelaselecaoimagem();
            },
            mtdselecionarimagem(event, op){
                this.extimgselecionada = util.extensaoarquivo(event.target.files[0]).toLowerCase();
                this.imgselecionada = URL.createObjectURL(event.target.files[0]);
                switch (op) {
                    case 'principal':
                        this.opimagem = 1;
                        this.mtdalteraproporcaocropper('livre');
                        break;
                    case 'secundaria':
                        this.opimagem = 2;
                        this.mtdalteraproporcaocropper('livre');
                        break;
                    case 'icone':
                        this.opimagem = 3;
                        this.mtdalteraproporcaocropper('1:1');
                        break;
                    case 'carrossel':
                        this.opimagem = 4;
                        this.mtdalteraproporcaocropper('27:9');
                        break;
                }
                this.$modal.show('modalCropImage')
                event.target.value = null;
            },
            mtdcancelaselecaoimagem(){
                // this.opimagem = 0;
                this.imgselecionada = null;
                this.extimgselecionada = null;
                this.aspectRatioCropper = null;
                this.scalableCropper    = false;
                this.$modal.hide('modalCropImage')
            },
            mtdalteraproporcaocropper(ratio){
                this.aspectRatioCropper = null;
                switch (ratio) {
                    case '1:1':
                        this.tituloCropper      = '1:1';
                        this.aspectRatioCropper = 1;
                        this.scalableCropper    = true;
                    break;
                    case '16:9':
                        this.tituloCropper      = '16:9';
                        this.aspectRatioCropper = 16 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '23:9':
                        this.tituloCropper      = '23:9';
                        this.aspectRatioCropper = 23 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '25:9':
                        this.tituloCropper      = '25:9';
                        this.aspectRatioCropper = 25 / 9;
                        this.scalableCropper    = true;
                    break;
                    case '27:9':
                        this.tituloCropper      = '27:9';
                        this.aspectRatioCropper = 27 / 9;
                        this.scalableCropper    = true;
                    break;
                    default:
                        this.tituloCropper      = 'Livre';
                        this.aspectRatioCropper = null;
                        this.scalableCropper    = false;
                    break;
                }
            },
            mtdconfirmaremoverimagem(pastaarquivo, nomearquivo){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a remoção da imagem?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'red',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-red',
                            action: function () {
                                vself.mtdremoverimagem(pastaarquivo, nomearquivo);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdconfirmaremoverimagemcarrossel(pastaarquivo, nomearquivo){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma remover o banner do carrossel?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'red',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-red',
                            action: function () {
                                vself.mtdremoverimagem(pastaarquivo, nomearquivo);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdremoverimagem(pastaarquivo, nomearquivo){
                let vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'op',           valor : 'deletararquivo'},
                    {parametro: 'pastaarquivo', valor : pastaarquivo},
                    {parametro: 'nomearquivo',  valor : nomearquivo},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/ecommerce/auxiliares.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (response.data.inf == 1){
                        vself.$toastr.s('A imagem foi removida!', 'Informação!');
                    }else{
                        vself.$toastr.e(response.data.inf, 'Erro!')
                    }
                    vself.mtdcarregaimagensecommerce()
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    vself.mtdcarregaimagensecommerce()
                });
            },
            mtddefinirtemafilial(){
                let vself  = this;
                let loader = vself.$loading.show();

                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'definetemafilial'},
                    {parametro: 'tema',         valor : vself.vtemafilial},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.005Z.010Z'},
                ];
                
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');

                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.msg)){
                        vself.$toastr.s('Tema de cores definido com sucesso!', 'Informação!');
                        vself.temafilial = response.data.temafilial;
                        console.log("Tema selecionado: "+vself.temafilial);
                    }
                    else{
                        let tpret = response.data.substring(0, 1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmatemafilial(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Deseja confirmar esse tema de cor?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                // console.log('descomentar metodo')
                                vself.mtddefinirtemafilial();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            }
                        }
                    }
                });
            },
            mtdcarregaimagensecommerce(){
                let vself  = this;
                vself.lstbannerscarrossel   = [];
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'carregaimagens'},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    console.log(response.data);
                    vself.logoprincipal         = response.data.logoprincipal[0]
                    vself.logosecundaria        = response.data.logosecundaria[0]
                    vself.logoicone             = response.data.icone[0]
                    vself.lstbannerscarrossel   = vself.mtdordenabannerscarrossel(response.data.bannerscarrossel);
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao carregar as imagens: '+response.message, 'Erro!');
                });
            },
            mtdordenabannerscarrossel(lstbanners){
                let lstordenada = lstbanners.sort((a, b) => {
                    const numA = parseInt(a.arquivo.split('-')[0]);
                    const numB = parseInt(b.arquivo.split('-')[0]);
                    return numA - numB;
                });
                return lstordenada;
            },

            //Luiz Trindade - Método que carrega o tema do ecommerce
            mtdcarregatemafilial(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'carregatemafilial'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial', valor: vself.idfilialselecionada},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    //Luiz Trindade - Definir o valor da variável de tema padrão, isto é, o tema que está em uso
                    vself.temafilial = response.data.temafilial;
                    vself.vtemafilial = response.data.temafilial;

                    switch (vself.vtemafilial){
                        case 'lilas':
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/lilas.png";
                            break;
                        case 'preto':
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/preto.png";
                            break;
                        case'vermelho':
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/vermelho.png";
                            break;
                        case 'laranja':
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/laranja.png";
                            break;
                        case'verde':
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/verde.png";
                            break;
                        default:
                            vself.urlpreviatema = "https://"+vself.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/padrao.png";
                            break;
                    }
                });
            },

            mtdlistaprodutosdestaque(destaque){
                this.destaquealterar = destaque;
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagemprodutosdestaque'},
                    {parametro: 'idfilial',     valor : vself.idfilialselecionada},
                    {parametro: 'iddestaque',   valor : destaque.id},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstprodutosdestaque = response.data.produtos;
                    vself.$modal.show('modalProdutosDestaque');
                    console.log(vself.lstprodutosdestaque)
                    
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                    
                });
            },
            mtdcancelaalteracaoprodutodestaque(){
                this.vcodproddestaque = null;
                this.vprodutodescricao = '';
                this.destaquealterar = {};
                this.$modal.hide('modalProdutosDestaque');
            },
            mtdconsultarprodutodestaque(){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);
			},
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vcodproddestaque			= produto.id;
							vself.vprodutodescricao 	    = produto.descricao;
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
						
						}
					}).catch(function (response) {
						loader.hide();
					});
				}
            },
            mtdincluirprodutodestaque(){
                let produto = {
                    jainserido : util.findValInArray(this.lstprodutosdestaque, 'idproduto', this.vcodproddestaque),
                    indexproduto : util.getArrayIndexForKey(this.lstprodutosdestaque, 'idproduto', this.vcodproddestaque)
                }
                if (!this.vcodproddestaque || !this.vprodutodescricao){
                    this.$toastr.w('Selecione um produto válido!', 'Atenção!');
                    $('#edcodprod').focus();
                    return;
                }
                if (produto.jainserido){
                    this.$toastr.w('Produto já adicionado ao destaque!', 'Atenção!');
                    $('#edcodprod').focus();
                    return;
                }
                this.lstprodutosdestaque.push({
                    idproduto: this.vcodproddestaque,
                    descricao: this.vprodutodescricao
                });
                this.vcodproddestaque = null;
                this.vprodutodescricao = '';
            },
            mtdremoverprodutodestaque(produto){
                console.log(produto);
                let indexproduto = util.getArrayIndexForKey(this.lstprodutosdestaque, 'idproduto', produto.idproduto)
                if (indexproduto >= 0){
                    this.lstprodutosdestaque.splice(indexproduto, 1);
                } else {
                    this.$toastr.e('Ocorreu um erro ao remover produto!', 'Erro!');
                }
            },
            mtdselect2_def(){
				let vself = this;
                
                $("#cbgrupocategoria").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbgrupos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidgrupocategoria = $("#cbgrupocategoria").val();
                });

                $("#cbplanopagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidplano = $("#cbplanopagamento").val();
                });

                $("#cbplanopagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidplano = $("#cbplanopagamento").val();
                });

                $("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
				});

                $("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				});

                $("#cbidformapix").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidformapix = $("#cbidformapix").val();
                });

                $("#cbcontapix").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcontasbancarias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcontapix = $("#cbcontapix").val();
                });
                
                $("#cbperfilfluxopix").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbperfisfluxocaixa',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidperfilfluxopix = $("#cbperfilfluxopix").val();                    
                });

                $("#cbidformacartaocred").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidformacartaocred = $("#cbidformacartaocred").val();
                });
                
                $("#cbcontacartaocred").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcontasbancarias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcontacartaocred = $("#cbcontacartaocred").val();
                });

                $("#cbperfilfluxocartaocred").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbperfisfluxocaixa',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidperfilfluxocartaocred = $("#cbperfilfluxocartaocred").val();                    
                });

                $("#cbtransportadora").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtransportadoras',
								c1: 'id',
								c2: 'razao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vtransportadora = $("#cbtransportadora").val();                    
                });
			},
            mtdcarregadadosfinanceiro(){
                var vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'carregadadosfinanceiros'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor : vself.idfilialselecionada},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (parseInt(response.data.idplano) > 0){
                        vself.vidplano      = response.data.idplano;   
                        var defplanopag = new Option(response.data.descplano, vself.vidplano, true, true);
                        $('#cbplanopagamento').append(defplanopag).trigger('change');
                    } else { vself.vidplano = null; }
                    if (parseInt(response.data.idestoque) > 0){
                        vself.videstoque    = response.data.idestoque;
                        var defestoque = new Option(response.data.descestoque, vself.videstoque, true, true);
                        $('#cbestoque').append(defestoque).trigger('change');
                    } else { vself.videstoque = null; }
                    if (parseInt(response.data.idvendedor) > 0){
                        vself.vidvendedor   = response.data.idvendedor;
                        var defvendedor = new Option(response.data.nomevendedor, vself.vidvendedor, true, true);
                        $('#cbvendedor').append(defvendedor).trigger('change');
                    } else { vself.vidvendedor = null; }

                    // carrega dados do método pix, se tiver
                    if(Object.keys(response.data.formaspag.pix).length > 0) {
                        vself.vformapix         = response.data.formaspag.pix.ativo == 1 ? true : false;
                        vself.swformapix        = vself.vformapix
                        vself.vtipochavepixpix  = response.data.formaspag.pix.tpchavepix;

                        if (vself.vtipochavepixpix == 0) {
                            vself.vtipochavepixpix = 'Chave CNPJ';
                            vself.vchavepixpix = vself.formatarCNPJ(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 1) {
                            vself.vtipochavepixpix = 'Chave CPF';
                            vself.vchavepixpix = vself.formatarCPF(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 2) {
                            vself.vtipochavepixpix = 'Chave Celular';
                            vself.vchavepixpix = vself.formatarCelular(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 3) {
                            vself.vtipochavepixpix = 'Chave Aleatória';
                            vself.vchavepixpix = response.data.formaspag.pix.chavepix.toLowerCase();
                        } else {
                            vself.vtipochavepixpix = '';
                            vself.vchavepixpix = '';
                        }

                        vself.vtipochavepixpix = vself.vchavepixpix == '' ? '' : vself.vtipochavepixpix; // Correção para não exibir tipo de chave se não houver chave

                        vself.vidformapix       = response.data.formaspag.pix.idforma;
                        vself.vidcontapix       = response.data.formaspag.pix.idconta;
    
                        var defformapix = new Option(response.data.formaspag.pix.descforma, vself.vidformapix, true, true);
                        $('#cbidformapix').append(defformapix).trigger('change');
                        var defcontapix = new Option(response.data.formaspag.pix.descconta, vself.vidcontapix, true, true);
                        $('#cbcontapix').append(defcontapix).trigger('change');
                        if (response.data.formaspag.pix.idperfilfluxo > 0){
                            var defperfilfluxopix = new Option(response.data.formaspag.pix.descperfilfluxo, response.data.formaspag.pix.idperfilfluxo, true, true);
                            $('#cbperfilfluxopix').append(defperfilfluxopix).trigger('change');
                        }
                    } else {
                        vself.vformapix         = false;
                        vself.swformapix        = vself.vformapix;
                        vself.vtipochavepixpix  = '';
                        vself.vchavepixpix      = '';
                        vself.vidformapix       = null;
                        vself.vidcontapix       = null;
                        vself.vidperfilfluxopix = null;
                    }

                    // carrega dados do método cartão de crédito, se tiver
                    if (Object.keys(response.data.formaspag.credito).length > 0) {
                        vself.vformacartaocred         = response.data.formaspag.credito.ativo == 1 ? true : false;
                        vself.swformacartaocred        = vself.vformacartaocred
                        vself.vidformacartaocred       = response.data.formaspag.credito.idforma;
                        vself.vidcontacartaocred       = response.data.formaspag.credito.idconta;
                        vself.vidperfilfluxocartaocred = response.data.formaspag.credito.idperfilfluxo;
                        vself.vapicartaocred           = response.data.formaspag.credito.apibanco;
    
                        var defformacartaocred = new Option(response.data.formaspag.credito.descforma, vself.vidformacartaocred, true, true);
                        $('#cbidformacartaocred').append(defformacartaocred).trigger('change');
                        var defcontacartaocred = new Option(response.data.formaspag.credito.descconta, vself.vidcontacartaocred, true, true);
                        $('#cbcontacartaocred').append(defcontacartaocred).trigger('change');
                        if (response.data.formaspag.credito.idperfilfluxo > 0){
                            var defperfilfluxocartaocred = new Option(response.data.formaspag.credito.descperfilfluxo, response.data.formaspag.credito.idperfilfluxo, true, true);
                            $('#cbperfilfluxocartaocred').append(defperfilfluxocartaocred).trigger('change');
                        }
                    } else {
                        vself.vformacartaocred         = false;
                        vself.swformacartaocred        = vself.vformacartaocred;
                        vself.vidformacartaocred       = null;
                        vself.vidcontacartaocred       = null;
                        vself.vidperfilfluxocartaocred = null;
                        vself.vapicartaocred           = null;
                    }

                    console.log(response.data);
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            },
            mtdconfirmaalteracaotabelaspadrao(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Deseja confirmar as alterações nas tabelas padrão?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdalteratabelaspadrao();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdalteratabelaspadrao(){
                if(this.vidplano === null){
                    this.$toastr.w('Selecione o plano de pagamento!', 'Atenção!');
                    return;
                }
                if(this.videstoque === null){
                    this.$toastr.w('Selecione o estoque padrão!', 'Atenção!');
                    return;
                }
                if(this.vidvendedor === null){
                    this.$toastr.w('Selecione o vendedor padrão!', 'Atenção!');
                    return;
                }

                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op'                    , valor: 'alterartabelaspadrao'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'idplano'               , valor: vself.vidplano},
                    {parametro: 'idestoque'             , valor: vself.videstoque},
                    {parametro: 'idvendedor'            , valor: vself.vidvendedor},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Tabelas padrão alteradas com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaalteracaopix(msg){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: `Deseja ${msg} o método de pagamento pix?`,
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdhabilitarmetodopix();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdhabilitarmetodopix(){
                if (this.vidformapix === null){
                    this.$toastr.w('Selecione a forma de pagamento!', 'Atenção!');
                    return;
                }
                if (this.vidcontapix === null){
                    this.$toastr.w('Selecione a conta bancária!', 'Atenção!');
                    return;
                }
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformapix,
                    'idconta'       : vself.vidcontapix,
                    'ativo'         : 1,
                    'idperfilfluxo' : vself.vidperfilfluxopix,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodopix'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento pix habilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmadesabilitarpix(){
                let vself = this;
                if (vself.swformapix && vself.vformapix) {
                    
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja desabilitar o método de pagamento pix?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'red',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-red',
                                action: function () {
                                    vself.mtddesabilitarmetodopix();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    vself.mtdcarregadadosfinanceiro();
                                    return
                                }
                            }
                        }
                    });
                }
            },
            mtddesabilitarmetodopix(){
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformapix,
                    'idconta'       : vself.vidcontapix,
                    'ativo'         : 0,
                    'idperfilfluxo' : vself.vidperfilfluxopix,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodopix'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento pix desabilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmaalteracaocartaocred(msg){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: `Deseja ${msg} o método de pagamento cartão de crédito?`,
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdhabiitarmetodocartaocred();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdhabiitarmetodocartaocred(){
                if (this.vidformacartaocred === null){
                    this.$toastr.w('Selecione a forma de pagamento!', 'Atenção!');
                    return;
                }
                if (this.vidcontacartaocred === null){
                    this.$toastr.w('Selecione a conta bancária!', 'Atenção!');
                    return;
                }
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformacartaocred,
                    'idconta'       : vself.vidcontacartaocred,
                    'ativo'         : 1,
                    'idperfilfluxo' : vself.vidperfilfluxocartaocred,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodocartaocred'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento CARTÃO DE CRÉDITO habilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmadesabilitarcartaocred(){
                let vself = this;
                if (vself.swformacartaocred && vself.vformacartaocred) {
                    
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja desabilitar o método de pagamento CARTÃO DE CRÉDITO?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'red',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-red',
                                action: function () {
                                    vself.mtddesabilitarmetodocartaocred();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    vself.mtdcarregadadosfinanceiro();
                                    return
                                }
                            }
                        }
                    });
                }
            },
            mtddesabilitarmetodocartaocred(){
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformacartaocred,
                    'idconta'       : vself.vidcontacartaocred,
                    'ativo'         : 0,
                    'idperfilfluxo' : vself.vidperfilfluxocartaocred,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodocartaocred'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtecommerceconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento CARTÃO DE CRÉDITO desabilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (vself.$route.params.idfilial) {
                        vself.idfilialselecionada = vself.$route.params.idfilial;
                    } else {
                        vself.$router.push({name: 'cadfiliais'});

                    }
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001L', vself.$store.state.perfilusuario)) {
                        vself.mtdcarregatemafilial();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            temaescolhidocomputado: function (){
                if (this.temafilial == 'lilas') {
                    return 'Lilás';
                } else if (this.temafilial == 'preto') {
                    return 'Preto';
                } else if (this.temafilial == 'vermelho') {
                    return 'Vermelho';
                } else if (this.temafilial == 'laranja') {
                    return 'Laranja';
                } else if (this.temafilial == 'verde') {
                    return 'Verde';
                } else {
                    return 'Padrão';
                }
            },
            urllogoprincipal: function(){
                if (!this.logoprincipal) {
                    return ''
                } else {
                    if (this.logoprincipal.patharquivo) {
                        return 'https://'+this.$store.state.usuario.adrsrv+'/'+this.logoprincipal.patharquivo
                    } else {
                        return ''
                    }
                }
            },
            urllogoprincipal: function(){
                if (!this.logoprincipal) {
                    return ''
                } else {
                    if (this.logoprincipal.patharquivo) {
                        return 'https://'+this.$store.state.usuario.adrsrv+'/'+this.logoprincipal.patharquivo
                    } else {
                        return ''
                    }
                }
            },
            urllogosecundaria: function(){
                if (!this.logosecundaria) {
                    return ''
                } else {
                    if (this.logosecundaria.patharquivo) {
                        return 'https://'+this.$store.state.usuario.adrsrv+'/'+this.logosecundaria.patharquivo
                    } else {
                        return ''
                    }
                }
            },
            urllogoicone: function(){
                if (!this.logoicone) {
                    return ''
                } else {
                    if (this.logoicone.patharquivo) {
                        return 'https://'+this.$store.state.usuario.adrsrv+'/'+this.logoicone.patharquivo
                    } else {
                        return ''
                    }
                }
            },
            ativadesativaincluirproduto(){
                if (!this.vcodproddestaque || !this.vprodutodescricao){
                    return true;
                }else{
                    return false;
                }
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },

        },
        watch:{
            vtemafilial: function(){
                // console.log(this.vtemafilial);
                switch (this.vtemafilial){
                    case 'lilas':
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/lilas.png";
                        break;
                    case 'preto':
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/preto.png";
                        break;
                    case'vermelho':
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/vermelho.png";
                        break;
                    case 'laranja':
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/laranja.png";
                        break;
                    case'verde':
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/verde.png";
                        break;
                    default:
                        this.urlpreviatema = "https://"+this.$store.state.usuario.adrsrv+"/controller/ecommerce/assets/previas-tema/padrao.png";
                        console.log(this.urlpreviatema);
                        break;
                }
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcodproddestaque = val;
					this.mtdlocalizarproduto(this.vcodproddestaque);					
                }
			},
            swformapix: function(){
                if(this.swformapix){
                    $('#dadosFormaPix').collapse('show')
                } else {
                    $('#dadosFormaPix').collapse('hide')
                }
            },
            swformacartaocred: function(){
                if(this.swformacartaocred){
                    $('#dadosFormaCartao').collapse('show')
                } else {
                    $('#dadosFormaCartao').collapse('hide')
                }
            },
            ativocorreios: function(){
                if(this.ativocorreios){
                    $('#dadosEntregaCorreios').collapse('show')
                } else {
                    $('#dadosEntregaCorreios').collapse('hide')
                }
            },
        }
    }
</script>
<style>
.tooltip-message {
    position: absolute;
    background-color: #343a40;
	color: #fff;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
    z-index: 1000;
    font-size: 13px;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.def-col-opcoess{
    width: 150px !important;
}
.def-col-opcoescat{
    width: 30px !important;
}
.def-col-cod{
    width: 80px !important;
}
.def-col-ativo{
    width: 200px !important;
}

.btn-incluir{
    width: 200px;
    margin-top: 21px;
}
.btn-definirtema{
    width: 170px;
    margin-top: 21px;
}
.container-cropper{
    & > .titulo-cropper{
        display: flex;
        justify-content: space-between;
    }
    & > .body-cropper{
        height: 50vh;
    }
}
.btns-cropper{
    display: flex;
    justify-content: space-between;
    margin-block: 20px;
}
.btns-editdestaque{
    display: flex;
    justify-content: end;
    margin-block: 20px;
    & > button {
        margin-left: 10px;
    }
}
.btns-editprodutos{
    display: flex;
    justify-content: end;
    margin-block: 15px;
    & > button {
        margin-left: 10px;
    }
}

.container-selecaoimagens{
    display: flex;
    align-items: center;
    margin: 10px;
    padding: 10px;
    background-color: #fff;
    & > label {
        width: 100%;
        margin-bottom: 5px;
    }
    & > small {
        margin-top: auto;
        width: 100%;
        font-size: 10px;
        color: #0d214e7b;
    }
}

.selecionar-imagem{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 150px;
    border-radius: 10px;
    background-color: transparent;
    border: 2px dashed #0d214e7b;
    transition: background-color 0.4s;
    & > i{
        font-size: 30px;
        color: #0d214e7b;
        margin-bottom: 8px;
    }
    &:hover{
        background-color: rgba(0, 33, 87, 0.059);
        cursor: pointer;
    }

    & > .icon-icone{
        font-size: 20px;
    }
    & > .span-icone{
        
        font-size: 10px;
    }
}

.imagem-selecionada{
    width: 100%;
    position: relative;
    padding: 10px;
    border-radius: 10px;
    border: 2px dashed #0d214e7b;
    background-color: #f5f5f5 !important;
}

.banners-carrossel{
    position: relative;
    & > .card {
        background-color: #fff;
        padding: 10px;
    }
}
.container-remover-imagem {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    &:hover > button {
        opacity: 1;
        margin-top: 4%;
        margin-left: 4%;
    }
    & > button {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 3px solid #784242;
        color: #fff;
        background-color: #9e0000;
        padding: 5px;
        font-size: 20px;
        font-weight: 600;
        opacity: 0;
        margin-top: 0;
        margin-left: 0;
        transition: all 0.4s;
        &:hover{
            color: #ffffffab;
            border: 3px solid #540000;
            background-color: #540202;
            
        }
    }
}
.aspectRatios {
    display: flex;
    margin-bottom: 10px;
}

.btn-aspectratio{
    height: 43px;
    width: 60px;
    margin: 5px;
    border: 1px solid #0d214e7b;
    border-radius: 5px;
    background-color: #fff;
    color: #0d214ef4;
    font-weight: 600;
    transition: background-color 0.4s;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 5px 0px #0000002f;
    &:hover{
        background-color: rgba(0, 33, 87, 0.676);
        color: #Fff;
        cursor: pointer;
    }
    & > div {
        border: 3px solid #0d214e7b;
    }
    &:hover > div {
        border: 3px solid #ffffffc4;
    }
    & > small {
        height: 10px;
        font-size: 10px;
    }

    & > .p1-1 {
        height: 20px;
        width: 20px;
    }
    & > .p27-9 {
        height: 15px;
        width: 30px;
    }
    & > .p25-9 {
        height: 18px;
        width: 30px;
    }
    & > .p23-9 {
        height: 20px;
        width: 30px;
    }
    & > .p16-9 {
        height: 22px;
        width: 30px;
    }
}

.container-previa-img {
    width: 60%;
    padding: 15px;
    border: 2px solid #0d214e7b;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px #0000002f;
}

.titulo-modal-destaque{
    display: flex;
    flex-direction: column;
    & > h2 {
        font-size: 20px;
        margin: 0;
    }
}

.btn-incluir-produto{
    width: 100%;
    margin-top: 21px;
}

.def-col-opproddest{
    width: 30px;
}

.card-footer-prod {
    padding-top: 0 !important;
}

.card .card-financeiro {
    background-color:#f2f2f2;
    padding: 8px;
    padding-block: 15px;
    margin-inline: 1px;
    flex-direction: row;
}
.card .card-entrega {
    background-color:#f2f2f2;
    padding: 8px;
    padding-block: 15px;
    margin-inline: 1px;
    flex-direction: row;
}

.btn-aplicar-metodo{
    margin-left: 20px;
    font-size: 13px !important;
}
</style>